import { useLoaderData } from 'react-router-dom';

export const useLoaderDataTyped = <T extends unknown>() => (
    useLoaderData() as T
);

export default useLoaderDataTyped;
